<template>
  <div  class="q-pa-lg" style="padding: 30px 200px">
    <div class="content">
      <div class="box">
        <div><img src="../../../static/CardDiagnosis/6.png" style="width:200px;height:200px;"></div>
        <div>
          <el-form style="background-color: #fff;" ref="form" :inline="true"  size="small" class="q-px-md q-pt-md">
            <el-form-item label-width="150px">
              <el-input  v-model.trim="iccid" placeholder="请输入卡号" />
            </el-form-item>
            <el-form-item>
              <el-button @click="diagnosis" plain type="primary" icon="el-icon-s-cooperation" style="padding:18px 25px;margin-left: 20%;">连接诊断</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-loading="loading" element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)" style="padding: 30px">
      <div class="diagnostic_results">
        <div class="border"></div>
        <div class="iccid">
          <div class="iccid_item">ICCID:{{form.iccid}}</div>
          <div v-if="form.cardStatus==='已激活'" class="state"><i class="el-icon-circle-check icon"></i>{{form.cardStatus}}</div>
          <div v-if="form.cardStatus==='已停用'" class="nostate"><i class="el-icon-circle-check icon"></i>{{form.cardStatus}}</div>
          <div v-if="form.cardStatus==='待激活'" class="infoState"><i class="el-icon-circle-check icon"></i>{{form.cardStatus}}</div>
        </div>
        <div style="margin-top: 2%;display: flex;flex-wrap: wrap">
          <div class="flex">
            <div style="width:268px;">上游卡号：<span class="flex_title">{{form.cardNo}}</span></div>
            <div style="width:268px;">自定义号码：<span class="flex_title">{{form.cardDefineNo}}</span></div>
            <div style="width:268px;">运营商：<span class="flex_title">{{form.iot}}</span></div>
          </div>

          <div class="flex">
            <div style="width:268px;">数据：<span class="flex_title">{{parseFloat(form.dataUsed).toFixed(2)}} MB<span style="color: red;margin-left: 2%">(运营商接口获取)</span></span></div>
            <div style="width:268px;">当前余额：<span class="flex_title">{{form.balance}} 元</span></div>
            <div style="width:268px;">最近轮询时间：<span class="flex_title">{{form.nextTime}}</span></div>
          </div>

          <div class="flex">
            <div style="width:268px;">状态：<span class="flex_title">{{form.cardStatus}}</span></div>
            <div style="width:268px;">是否销户：<span class="flex_title">{{form.xkStatus}}</span></div>
            <div style="width:268px;">是否实名：<span class="flex_title">{{form.isAuth}}</span></div>
          </div>
          <div class="flex">
            <div style="width:268px;">达量断网阈值：<span class="flex_title">{{form.dlCutFlow}}</span></div>
            <div style="width:268px;">是否轮询：<span class="flex_title">{{form.isPooling}}</span></div>
            <div style="width:268px;">轮询限速率：<span class="flex_title">{{form.limitValue}}</span></div>
          </div>
        </div>

        <div class="result">诊断结果</div>
        <div class="border"></div>
      </div>
      <!-- 诊断结果 -->
      <div class="ShowResults">
        <div class="ShowResults_left">
          <img src="../../../static/CardDiagnosis/4.png" class="img">
          <div class="ShowResults_left_title">通讯状态 <i class="el-icon-question icon"></i></div>
        </div>
        <div v-if="form.cardStatus==='已激活'" class="ShowResults_right">
          <div class="ShowResults_right_title"><i class="el-icon-circle-check"></i>&nbsp;已通过</div>
          <div class="ShowResults_right_title_communication">(SIM卡状态允许通讯)</div>
        </div>
        <div v-else class="ShowResults_right">
          <div class="ShowResults_right_titleNO"><i class="el-icon-circle-close"></i>&nbsp;未通过</div>
          <div class="ShowResults_right_title_communication">(SIM卡状态不允许通讯)</div>
        </div>
      </div>
      <div class="border1"></div>

      <div class="ShowResults">
        <div class="ShowResults_left">
          <img src="../../../static/CardDiagnosis/4.png" class="img">
          <div class="ShowResults_left_title">网络连接 <i class="el-icon-question icon"></i></div>
        </div>
        <div  class="ShowResults_right">
          <div class="ShowResults_right_title"><i class="el-icon-circle-check"></i>&nbsp;已通过</div>
          <div class="ShowResults_right_title_communication">{{form.nowFlow}}</div>
        </div>
      </div>
      <div class="border1"></div>

      <div class="ShowResults">
        <div class="ShowResults_left">
          <img src="../../../static/CardDiagnosis/3.png" class="img">
          <div class="ShowResults_left_title">网速检测 <i class="el-icon-question icon"></i></div>
        </div>
        <div  class="ShowResults_right">
          <div class="ShowResults_right_title"><i class="el-icon-circle-check"></i>&nbsp;已通过</div>
          <div class="ShowResults_right_title_communication">({{form.limitValue===null?'未检测到限速':form.limitValue}})</div>
        </div>
      </div>
      <div class="border1"></div>
      <div class="ShowResults">
        <div class="ShowResults_left">
          <img src="../../../static/CardDiagnosis/5.png" class="img">
          <div class="ShowResults_left_title">资源检测 <i class="el-icon-question icon"></i></div>
        </div>
        <div class="ShowResults_right">
          <div class="ShowResults_right_title"><i class="el-icon-circle-check"></i>&nbsp;已通过</div>
          <div class="ShowResults_right_title_communication">({{form.iot}})</div>
        </div>

      </div>
      <div class="border1"></div>
      <div class="ShowResults">
        <div class="ShowResults_left">
          <img src="../../../static/CardDiagnosis/2.png" class="img">
          <div class="ShowResults_left_title">互联网服务 <i class="el-icon-question icon"></i></div>
        </div>
        <div v-if="form.cardStatus==='已激活'" class="ShowResults_right">
          <div class="ShowResults_right_title"><i class="el-icon-circle-check"></i>&nbsp;已通过</div>
          <div class="ShowResults_right_title_communication">(SIM卡已成功产生数据会话)</div>
        </div>
        <div v-else class="ShowResults_right">
          <div class="ShowResults_right_titleNO"><i class="el-icon-circle-close"></i>&nbsp;(SIM卡已注册，但最近没有无线活动)</div>
          <div class="ShowResults_right_title_communication"><span class="ShowResults_right_titleNO">处理建议：</span>确认设备已开启，若有可能，请关闭设备然后重新启动</div>
        </div>
      </div>
      <div class="border1"></div>
    </div>

  </div>

</template>

<script>

export default {
  name: 'connectionDiagnosis',

  mounted: function () {
    let _this = this
    _this.iccid= _this.$route.query.iccid
  },
  data() {
    return {
      loading: false,
      iccid: '',
      form: {},
      relatedCdId_show: false,
      SetMealImport: false,
      FlowData: [],
      selIccid: [{ FlowData: [] }],
      activeNames: [0],
      realName:'',
      cardStatus:'',
      show1:false,
      show2:false,
      txzt1:false,
      txzt2:false,
      hlwfw1:false,
      hlwfw2:false,
      wlxs1:false,
      wlxs2:false,
      zyjc1:false,
      zyjc2:false,
      cardjs: require('../../../api/card'),
    }
  },

  methods: {


    diagnosis() {
      let _this = this
      if (_this.iccid === '') {
        _this.$alert('请输入要诊断的号码')
        return false
      }
      _this.form = {}
      _this.relatedCdId_show = false
      _this.FlowData = [] //重置
      _this.loading = true

      _this.cardjs.getDiagnosis(_this.iccid).then(res => {
        if (res.data.code === '0') {
          _this.loading = false
          _this.form = res.data.data

        } else {
          _this.$alert(res.data.msg)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}
/deep/ .el-input__inner {
  width: 300px;
  height: 50px;
}
.diagnostic_results {
  width: 100%;
}
.border {
  width: 100%;
  border-bottom: 2px dashed #f4f4f4;
}
.iccid {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .iccid_item {
    font-size: 19px;
    font-weight: 700;
    margin-right: 10px;
  }
  .state {
    border: 1px solid #2bd934;
    padding: 1px 7px;
    color: #2bd934;
    border-radius: 12px;
    .icon {
      padding-right: 3px;
    }
  }
  .infoState {
    border: 1px solid rgba(42, 51, 32, 0.71);
    padding: 1px 7px;
    color: rgba(42, 51, 32, 0.71);
    border-radius: 12px;
    .icon {
      padding-right: 3px;
    }
  }
  .nostate {
    border: 1px solid #ff0000;
    padding: 1px 7px;
    color: #ff0000;
    border-radius: 12px;
    .icon {
      padding-right: 3px;
    }
  }
}
.flex {
  justify-content: space-between;
  font-size: 15px;
  color: #666666;
  width: 90%;
  margin-top: 10px;
  .flex_title {
    color: #333;
    font-weight: 700;
    word-wrap: break-word;
  }
}
.result {
  font-size: 19px;
  font-weight: 700;
  margin: 30px 0px 20px 0px;
}
// 诊断结果
.ShowResults {
  display: flex;
  align-items: center;
  margin: 20px 0px;
  .ShowResults_left {
    display: flex;
    align-items: center;
    width: 212px;
    .img {
      width: 50px;
      height: 50px;
      margin-right: 20px;
    }
    .ShowResults_left_title {
      font-size: 15px;
      color: #666;
      .icon {
        font-size: 17px;
        color: #666;
      }
    }
  }
  .ShowResults_right {
    display: flex;
    flex-direction: column;
    margin-left: 10%;
    .ShowResults_right_title {
      color: #2bd934;
    }
    .ShowResults_right_titleNO {
      color: #ff0000;
    }
    .ShowResults_right_title_communication {
      color: #a6a6a6;
    }
  }
}
.border1 {
  width: 100%;
  border-bottom: 2px solid #f5f5f5;
}
</style>

<style scoped lang="less">
/deep/.el-table .el-table__cell {
  padding: 0px !important;
}
/deep/thead.has-gutter {
  height: 40px;
}
.carInfo {
  display: flex;
  flex-wrap: wrap;

  background: #ffffff;
  .my_item {
    display: flex;
    padding: 0 20px;

    line-height: 44px;
    color: #666666;
    text-align: center;
    flex: 0 0 50%;
    border: 1px solid #ebeef5;
    .my_title {
      font-weight: bold;
    }
    .my_labe {
      color: #666666;
    }
    &:nth-child(4n + 1) {
      border-left: 1px solid #ebeef5;
    }
    &:nth-last-child(1),
    &:nth-last-child(4),
    &:nth-last-child(3),
    &:nth-last-child(2) {
      border-bottom: 1px solid #ebeef5;
    }
  }
}


/deep/ .el-collapse-item__header {
  display: none;
}
</style>
